import React, { useEffect, useRef } from 'react'
import Head from 'next/head'
import PropTypes from 'prop-types'
import NextApp from 'next/app'
import { SiteConfigProvider } from '@paper-monster/web/src/components/Providers/SiteConfigProvider'
import { NonceContext } from '@paper-monster/web/src/utils/nonce'
import { initializeClientHints } from '@paper-monster/web/src/utils/client-events'
import '@paper-monster/web/src/utils/rollbar'

import App from '@/components/App'
import { SITE_CONFIG } from '@/config'
import '@/styles/globals.scss'

function MyApp({ Component, pageProps, nonce }) {
  const nonceRef = useRef(nonce)

  useEffect(() => {
    if (nonce) {
      nonceRef.current = nonce
    }
  }, [nonce])

  useEffect(() => {
    initializeClientHints()
  }, [])

  // The shared components read this nonce context, so the app provides that
  // one rather than a context of its own.
  return (
    <NonceContext.Provider value={nonceRef.current}>
      <SiteConfigProvider config={SITE_CONFIG}>
        <Head>
          <meta content="width=device-width, initial-scale=1" name="viewport" />
          <link href="/favicon.ico" rel="shortcut icon" />
        </Head>
        <App layoutProps={{ ...Component.layoutProps }}>
          <Component {...pageProps} />
        </App>
      </SiteConfigProvider>
    </NonceContext.Provider>
  )
}

MyApp.getInitialProps = async (
  Context,
) => {
  const props = await NextApp.getInitialProps(Context)
  const { ctx } = Context
  const nonce = ctx.req?.headers?.['x-nonce']

  return {
    ...props,
    nonce,
  }
}

MyApp.propTypes = {
  Component: PropTypes.func,
  pageProps: PropTypes.shape({}),
  nonce: PropTypes.string,
}

export default MyApp
